import type { PlaybackEvent } from '@/api/types'

// Мост WS-стрим → плеер. useJobsStream живёт в JobsStreamProvider ВЫШЕ PlayerProvider и
// про плеер не знает — он только публикует сюда, плеер подписан. Без React-состояния:
// доставка не ре-рендерит ни стрим, ни страницы.
// - event  — playback-событие с любого устройства пользователя (в т.ч. наше же эхо);
// - resync — WS (пере)подключился (пришёл snapshot): события за время разрыва могли
//   потеряться, позицию надо перечитать с сервера.
export type PlaybackSignal = { type: 'event'; event: PlaybackEvent } | { type: 'resync' }

type Listener = (signal: PlaybackSignal) => void

const listeners = new Set<Listener>()

export function publishPlaybackSignal(signal: PlaybackSignal): void {
  for (const listener of listeners) listener(signal)
}

export function subscribePlaybackSignals(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
